<!-- home-carousel.component.html -->
<div class="relative">
  <button 
    (click)="previous()" 
    class="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-black/30 hover:bg-black/50 text-white p-2 rounded-r-lg">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
    </svg>
  </button>

  <div 
    #container 
    (mouseenter)="stopAutoSlide()"
    (mouseleave)="startAutoSlide()"
    class="w-full max-w-screen overflow-x-auto py-5 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
    <div class="flex flex-nowrap gap-4 px-5">
      <div 
        *ngFor="let item of items; let i = index"
        [ngClass]="{'scale-105 transition-transform': i === currentIndex}"
        class="flex-none w-48 aspect-square relative cursor-pointer"
        [routerLink]="['/tea-item', item.slug]"
      >
        <img 
          [src]="item.image | imageModifier:{width:512} | async" 
          [alt]="item.name"
          [ngClass]="{'border-4 border-green-800': i === currentIndex}"
          class="w-full h-full object-cover rounded-lg drop-shadow-lg">
        <div class="absolute bottom-0 left-0 right-0 bg-black/60 p-2 rounded-b-lg">
          <h3 class="text-white text-sm text-center m-0">{{item.name}}</h3>
        </div>
      </div>
    </div>
  </div>

  <button 
    (click)="next()" 
    class="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-black/30 hover:bg-black/50 text-white p-2 rounded-l-lg">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
    </svg>
  </button>
</div>